import * as api from '@gitbook/api-client';

import { useCurrentOrganization, useTrial, useGetUpgradeAction } from '../../state';
import { useAgentUsage } from './useAgentUsage';

/**
 * Maximum number of change request agent messages a free user (not on trial) can send per week.
 */
export const CHANGE_REQUEST_AGENT_FREE_WEEKLY_LIMIT = 10;

/**
 * Return whether the current user is subject to the weekly message limit for the change request
 * agent and, if so, how close they are to it.
 *
 * The limit applies to any user whose plan does not include the `ai-writing` feature (Free, Plus,
 * legacy Plus, …) and who is not on an active trial. Users on a plan that ships the feature, or
 * who are currently trialing it, are not limited.
 */
export function useChangeRequestAgentLimit() {
    const organization = useCurrentOrganization();
    const trial = useTrial({ organization });
    const upgrade = useGetUpgradeAction({
        organization,
        featureKey: api.OrganizationFeature.AiWriting,
    });
    const { weeklyTotal } = useAgentUsage();

    const upgradeRequired = Boolean(upgrade);
    const isOnActiveTrial = trial.status === api.BillingTrialStatus.Active;
    const isLimited = upgradeRequired && !isOnActiveTrial;
    const limit = CHANGE_REQUEST_AGENT_FREE_WEEKLY_LIMIT;
    const isLimitReached = isLimited && weeklyTotal >= limit;

    return {
        isLimited,
        isLimitReached,
        limit,
        weeklyTotal,
    };
}
